import {useEffect} from "react";
import "./MobileTouchFX.scss";

const INTERACTIVE =
  ".main-button, .project-card, .experience-card, .experience-card-dark, .education-card, .skills-list-item, .software-skill-inline, .project-link, .contact-detail, .contact-detail-email, .footer-top-link, .greeting-ghost-link, .exp-nav-btn, .projects-mobile-dot, .icon-button, .nav-link, .section-eyebrow, .greeting-highlights li, .greeting-stats li";

export default function MobileTouchFX({enabled = true}) {
  useEffect(() => {
    if (!enabled) return undefined;

    const coarse = window.matchMedia("(pointer: coarse)").matches;
    const narrow = window.matchMedia("(max-width: 768px)").matches;
    if (!coarse && !narrow) return undefined;

    const onTouch = e => {
      const touch = e.changedTouches[0];
      if (!touch) return;

      const target = e.target.closest(INTERACTIVE);
      if (target) {
        target.classList.add("is-touch-active");
        window.setTimeout(() => target.classList.remove("is-touch-active"), 280);

        const spark = document.createElement("span");
        spark.className = "mobile-touch-spark";
        spark.style.left = `${touch.clientX}px`;
        spark.style.top = `${touch.clientY}px`;
        document.body.appendChild(spark);
        const sparkCleanup = () => spark.remove();
        spark.addEventListener("animationend", sparkCleanup, {once: true});
        setTimeout(sparkCleanup, 500);
      }

      const ripple = document.createElement("span");
      ripple.className = "mobile-touch-ripple";
      ripple.style.left = `${touch.clientX}px`;
      ripple.style.top = `${touch.clientY}px`;
      document.body.appendChild(ripple);

      const cleanup = () => ripple.remove();
      ripple.addEventListener("animationend", cleanup, {once: true});
      setTimeout(cleanup, 800);
    };

    document.addEventListener("touchstart", onTouch, {passive: true});
    return () => document.removeEventListener("touchstart", onTouch);
  }, [enabled]);

  return null;
}
